import { ParameterType } from '@/study-search/enums';

import { FilterDefinition } from './FilterDefinition';
import {FilterOptionInformation} from '@studyportals/search-filters';
import { EducationLevelFilterOptionValue } from '@studyportals/search-filters/server-side';

class EducationLevelFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.EDUCATION_LEVEL,
			[
				new FilterOptionInformation('Bachelor', EducationLevelFilterOptionValue.BACHELOR, '', ''),
				new FilterOptionInformation('Master', EducationLevelFilterOptionValue.MASTER, '', ''),
				new FilterOptionInformation('PhD', EducationLevelFilterOptionValue.PHD, '', ''),
				new FilterOptionInformation('Short Course', EducationLevelFilterOptionValue.SHORT_COURSE, '', ''),
			],
			[],
		);
	}
}

export default new EducationLevelFilterDefinition();
